import * as React from 'react';
import { SVGProps } from 'react';

const FileIconJsonSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <g opacity={0.6} fill="#fff">
      <path d="M9.596 23.833c-1.461-.016-2.191-.64-2.191-1.87v-1.817c0-.812-.32-1.239-.96-1.28v-.899c.64-.04.96-.476.96-1.305v-1.766c0-1.248.73-1.88 2.19-1.896v.954c-.652.016-.978.408-.978 1.176v1.736c0 .828-.408 1.34-1.225 1.532v.019c.817.18 1.225.687 1.225 1.52v1.717c0 .44.072.751.216.936.147.189.402.287.763.295v.948ZM16.555 18.866c-.636.041-.954.468-.954 1.28v1.816c0 1.231-.726 1.855-2.179 1.871v-.948c.357-.008.61-.106.758-.295.151-.189.227-.5.227-.936v-1.717c0-.833.404-1.34 1.213-1.52v-.019c-.809-.193-1.213-.704-1.213-1.532V15.13c0-.768-.328-1.16-.985-1.176V13c1.453.016 2.18.648 2.18 1.896v1.766c0 .83.317 1.264.953 1.305v.899Z" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 7.4c0 .56-.14.967-.42 1.22-.273.253-.7.38-1.28.38h-.6c-.58 0-1.01-.127-1.29-.38-.273-.253-.41-.66-.41-1.22V5.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38h.6c.58 0 1.007.127 1.28.38.28.253.42.66.42 1.22v1.8Zm-1-1.75c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17h-.5c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.5c.247 0 .433-.057.56-.17.127-.113.19-.273.19-.48v-1.7Z"
      fill="#fff"
    />
    <path
      d="M10 7.75c0 .42-.13.733-.39.94-.253.207-.623.31-1.11.31H7V8h1.45c.18 0 .317-.037.41-.11A.423.423 0 0 0 9 7.55v-.1c0-.3-.143-.45-.43-.45H8.2c-.467 0-.667-.1-.9-.3-.227-.207-.3-.53-.3-.97v-.47c0-.447.087-.767.34-.96.253-.2.667-.3 1.16-.3H10v1H8.55c-.167 0-.3.04-.4.12-.1.073-.15.183-.15.33v.11c0 .153.043.267.13.34.093.073.21.1.35.1h.15c.447 0 .787.12 1.02.34.233.213.35.533.35.96v.45Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 4v.24c.207-.16.473-.24.8-.24h.6c.54 0 .94.127 1.2.38.267.253.4.66.4 1.22V9h-1V5.65c0-.2-.06-.357-.18-.47-.113-.12-.27-.18-.47-.18h-.7c-.22 0-.383.06-.49.18a.53.53 0 0 0-.16.37V9h-1V4h1ZM5.5 3V2h-1v1h1ZM4.4 9.91a.338.338 0 0 1-.25.09H3v1h1.46c.307 0 .557-.1.75-.3.193-.193.29-.46.29-.8V4h-2v1h1v4.7a.256.256 0 0 1-.1.21Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconJsonSizeS;
